import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { SvgStyled } from './styled';

export type TSvgSizeProps = {
    size: number,
    width?: never,
    height?: never,
} | {
    size?: never,
    width: number,
    height: number,
} | {
    size?: never,
    width?: never,
    height?: never,
}

export type TBaseSvgProps = {
    id: string,
    viewBox: string,
    role?: string,
    strokeWidth?: number,
    children?: ReactNode,
    onClick?: () => void,
} & TSvgSizeProps;

const Svg = ({ role = 'img', size = 24, width, height, ...props }: TBaseSvgProps): JSX.Element => {
    if (!width && !height) {
        width = size;
        height = size;
    }

    return (
        <SvgStyled
            xmlns='http://www.w3.org/2000/svg'
            role={role}
            width={width}
            height={height}
            {...props}
        />
    );
};

export default styled(Svg)``;
